export default {
  nav: 30,
  subnav: 20,
  modal: 40,
};
